import { Box, Button } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { withRouter } from "react-router"
import styled from "styled-components"

import Textarea from "components/landing/textarea"
import { logCurrentPageInCollectionStats } from "helpers/collection"
import scrollToTop from "helpers/scroll-to-top"

import CollectionItems from "./collection-items"

const ScrollToTop = styled(Button).attrs((props) => ({
  color: "black",
  variant: "text",
  ...props,
}))`
  font-size: 14px;
  text-decoration: underline;
  :hover,
  :active {
    text-decoration: none;
  }
`

const ProductCollection = ({ element, lazyload, location }) => (
  <Box
    contain
    onClick={() => logCurrentPageInCollectionStats(location.pathname)}
  >
    <Box mb={7} px={{ _: "10px", tablet: 0 }} {...element.style}>
      {element.textarea && (
        <Textarea
          element={element.textarea}
          linkClickData={element?.anchor_name || element?.id}
          style={element.textarea.style}
        />
      )}
      {element.enable_back_to_top && (
        <Box mb={2} mt={-1} px={{ _: 0, tablet: 2 }}>
          <ScrollToTop onClick={() => scrollToTop()}>Back To Top</ScrollToTop>
        </Box>
      )}
      <CollectionItems
        id={element.id}
        items={element.items}
        lazyload={lazyload}
        linkClickData={element.anchor_name || element.id}
      />
    </Box>
  </Box>
)

ProductCollection.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
  location: PropTypes.object,
}

export default withRouter(ProductCollection)
